import {
  Box,
  Heading,
  Highlight,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FAQsV2 } from "../../_components/FAQs";
import Footer from "../../_components/Footer";
import { Section } from "../landing/components/Section";
import {
  businessFAQs,
  communityFAQs,
  homeownerFAQs,
  skilledWorkersFAQs,
} from "./constants";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";

export const FAQ = () => {
  const [index, setIndex] = useState(0);

  const searchParams = new URLSearchParams(window.location.search);

  const tab = searchParams.get("tab");

  useEffect(() => {
    if (tab) {
      const index = sections.findIndex(
        (section) => section.title.toLowerCase() === tab
      );

      const usedIndex = index < 0 ? 0 : index;

      setIndex(usedIndex);
    }
  }, [tab]);

  const navigate = useHistory().push;

  const sections = [
    {
      title: "Businesses",
      items: businessFAQs,
    },
    {
      title: "Community",
      items: communityFAQs,
    },
    {
      title: "Homeowners",
      items: homeownerFAQs,
    },
    {
      title: "Artisans",
      items: skilledWorkersFAQs,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions</title>
        <meta
          name="description"
          content="Got Questions? We're here to help!
Here are some of our frequently asked questions. For more enquiries, don't hesitate to contact us.
"
        />
      </Helmet>
      <VStack spacing={0}>
        <Section bg="gray.50">
          <VStack
            w="full"
            spacing={4}
            py={{
              base: 10,
              lg: 24,
            }}
          >
            <Heading
              fontSize={{
                base: 26,
                md: 52,
              }}
              textAlign="center"
              lineHeight="normal"
            >
              <Highlight
                query={["Got Questions?"]}
                styles={{
                  fontWeight: "normal",
                  color: "gray.400",
                }}
              >
                Got Questions?
              </Highlight>
              <br />
              We&apos;re here to help!
            </Heading>
            <Text
              fontSize={{
                base: 15,
                md: 24,
              }}
              fontWeight="medium"
              color="gray.500"
              w={{
                base: "80%",
                lg: "50%",
              }}
              textAlign="center"
            >
              Here are some of our frequently asked questions. For more
              enquiries, don&apos;t hesitate to contact us.
            </Text>
          </VStack>
        </Section>
        <HStack
          w="full"
          bgColor="#FEFEFE"
          justifyContent="center"
          position="relative"
        >
          <VStack
            zIndex={99}
            px={5}
            pt={{
              base: 8,
              lg: 20,
            }}
            spacing={{
              base: 6,
              lg: 8,
            }}
            w="full"
            maxW="container.xl"
            alignItems="center"
          >
            <Tabs
              index={index}
              onChange={(index) => setIndex(index)}
              size="lg"
              variant="unstyled"
              w="full"
              align="center"
            >
              <TabList>
                {sections.map(({ title }) => (
                  <Tab
                    fontSize={{
                      base: 15,
                      lg: 32,
                    }}
                    fontWeight="medium"
                    color="gray.400"
                    key={title}
                    _selected={{
                      color: "prussianBlue.900",
                    }}
                  >
                    {title}
                  </Tab>
                ))}
              </TabList>
              <TabPanels>
                {sections.map(({ items, title }) => (
                  <TabPanel key={title} px={0}>
                    <FAQsV2 items={items} />
                  </TabPanel>
                ))}
              </TabPanels>
            </Tabs>
          </VStack>
        </HStack>
        <Footer
          ctaTitle="Get skilled professionals to care for all your home needs."
          primaryCtaLabel="Hire a Pro"
          onPrimaryCta={() => {
            navigate("/auth/register");
          }}
        />
      </VStack>
    </>
  );
};
